// extracted by mini-css-extract-plugin
export default {"reportContainer":"CampaignCustomerReportPage_reportContainer__D84oO"};